'use strict';

/**
 * Loads the customer sites that are selectable for a given company code (booking circle).
 * Backed by the existing neucode endpoint GET /business-partner/customer/sites/selectable
 * (EPROC-10907, CustomerSiteController#findSelectableSites). Mirrors material-group.service.js,
 * but the site list is flat and scoped to a company code instead of a hierarchy.
 */
module.exports = /* @ngInject */ function (apiConfig, httpService) {

    function getSelectable(companyCodeId) {
        const normalizedCompanyCodeId = normalizeValue(companyCodeId);
        // Without a company code there is no valid selection (Position.Site.CompanyCode =
        // Document.CompanyCode), so return an empty list -- matches the backend behaviour.
        if (!normalizedCompanyCodeId) {
            return Promise.resolve([]);
        }

        const uri = apiConfig.getBase('business-partner', 'customer', 'sites', 'selectable');
        uri.query.companyCodeId = normalizedCompanyCodeId;

        return httpService.get(uri.toString(), {
            isArray: true,
            transformResponse: (response) => parseArray(response).map(mapSite),
        });
    }

    function getByCode(siteCode, companyCodeId) {
        const normalizedCode = normalizeValue(siteCode);
        if (!normalizedCode) {
            return Promise.resolve(null);
        }

        return getSelectable(companyCodeId)
            .then((sites) => (sites || []).find((site) => site.code === normalizedCode) || null)
            .catch((error) => {
                console.error(error);
                return null;
            });
    }

    function parseArray(response) {
        if (!response) {
            return [];
        }

        try {
            const parsed = typeof response === 'string' ? JSON.parse(response) : response;
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    function mapSite(dto) {
        const code = dto?.code || '';
        const name = dto?.name || '';

        return {
            code,
            name,
            label: code && name ? `${code} - ${name}` : code || name || '',
        };
    }

    function normalizeValue(value) {
        if (typeof value === 'undefined' || value === null) {
            return '';
        }

        return String(value).trim();
    }

    return {
        getSelectable,
        getByCode,
    };
};
